// removed by extract-text-webpack-plugin
module.exports = {"PrimaryNavigation":"PrimaryNavigation","PrimaryNavigation__heading":"PrimaryNavigation__heading","PrimaryNavigation__list-ul":"PrimaryNavigation__list-ul","PrimaryNavigation__link":"PrimaryNavigation__link","blank":"blank","PrimaryNavigation__link-pc":"PrimaryNavigation__link-pc","PrimaryNavigation__link-mb":"PrimaryNavigation__link-mb"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/primary-navigation/styles.css
// module id = 698
// module chunks = 0 1